import React from "react"
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell, LabelList } from "recharts"
import { CHART_COLORS } from "../constants"

export default function FunnelChart({ stages = [] }) {
  if (!stages.length) return null

  const maxReached = Math.max(...stages.map((s) => s.reached || 0), 1)
  const data = stages.map((s) => ({
    name: s.name,
    reached: s.reached || 0,
    conversionRate: s.conversion_rate,
    width: ((s.reached || 0) / maxReached) * 100,
  }))

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">Funnel</div>
      <ResponsiveContainer width="100%" height={Math.max(stages.length * 56, 180)}>
        <BarChart data={data} layout="vertical" barCategoryGap="20%">
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12 }} />
          <YAxis dataKey="name" type="category" tick={{ fontSize: 12 }} width={120} />
          <Tooltip
            formatter={(value, _name, props) => {
              const rate = props.payload.conversionRate
              return [`${value} reached${rate != null ? ` (${rate}% → next)` : ""}`, "Deals"]
            }}
          />
          <Bar dataKey="reached" radius={[0, 4, 4, 0]}>
            {data.map((_, i) => (
              <Cell
                key={i}
                fill={i === data.length - 1 ? CHART_COLORS.won : CHART_COLORS.primary}
                fillOpacity={1 - i * 0.12}
              />
            ))}
            <LabelList dataKey="reached" position="right" style={{ fontSize: 12, fill: "#475569" }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
